import { Box, BoxProps } from '@theme-ui/components';
import * as React from 'react';

type InheritedProps = Omit<BoxProps, 'ref'>;
export interface AbsoluteProps extends InheritedProps {
  top?: string | number;
  bottom?: string | number;
  left?: string | number;
  right?: string | number;
}

export const AbsolutePosition = React.forwardRef<HTMLDivElement, AbsoluteProps>(
  ({ top, bottom, left, right, ...props }, ref) => {
    return (
      <Box
        ref={ref}
        {...props}
        // @ts-ignore
        __css={{
          position: 'absolute',
          top,
          bottom,
          left,
          right
        }}
      />
    );
  }
);
